export const imgErrorHandler = e => {
    e.target.src = '/assets/img/defaultImage.jpg';
}

export const DEFAULT_IMG = '/assets/img/defaultImage.jpg';